var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sign-app-wrapper"},[_vm._t("default",function(){return [_c('a',{staticClass:"sign-app-btn",on:{"click":_vm.openModal}},[_c('span',[_vm._v("Войти")])])]},{"open":_vm.openModal}),_c('ModalSignWrapper',_vm._g(_vm._b({attrs:{"phone":_vm.phone}},'ModalSignWrapper',_vm.$attrs,false),_vm.listeners))],2)
}
var staticRenderFns = []

export { render, staticRenderFns }